import { STATI_PROPOSTA, STATI_PROPOSTA_LOOKUP } from '../../constants'

export const proposteInitFilters = (params: URLSearchParams) => {
  const defaultStato = [
    STATI_PROPOSTA_LOOKUP.inviata.value,
    STATI_PROPOSTA_LOOKUP.sollecitata.value,
    STATI_PROPOSTA_LOOKUP.accettata.value,
  ]

  const statoTouched = params.has('stato__touched')
  const statoIn = statoTouched ? params.getAll('stato__in') : defaultStato

  return {
    page: Number(params.get('page') ?? 1),
    search: params.get('search') ?? '',
    ordering: params.get('ordering') ?? '-id',
    data_creazione__lte: params.get('data_creazione__lte') ?? '',
    data_creazione__gte: params.get('data_creazione__gte') ?? '',
    cliente: params.get('cliente') ?? '',
    stato: params.get('stato') ?? '',
    stato__in: statoIn,
    stato__touched: statoTouched,
  }
}
